<template>
  <div>
    <h1>创建Banner分类</h1>
    <el-form label-width="120px" @submit.native.prevent="saveBannerCate">
      <el-form-item label="分类名称">
        <el-input v-model="model.bannerType"></el-input>
      </el-form-item>
      <el-form-item label="分类描述">
        <el-input v-model="model.bannerDesc"></el-input>
      </el-form-item>
      <el-form-item label="bannerID(自动生成)">
        <el-input v-model="bannerID" @input="createBannerID"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" native-type="submit">点击创建</el-button>
      </el-form-item>
    </el-form>

    <h1>Banner分类列表</h1>
    <el-table :data="bannercate" style="width: 100%">
      <el-table-column
        prop="createAt"
        label="创建日期"
        :formatter="formatDate"
        width="180"
      >
      </el-table-column>
      <el-table-column prop="bannerType" label="Banner分类" width="180">
      </el-table-column>
      <el-table-column prop="bannerID" label="分类ID"> </el-table-column>
      <el-table-column prop="bannerDesc" label="分类描述"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            @click="delBannerCate(scope.row._id)"
            type="danger"
            size="small"
            plain
            icon="el-icon-delete"
            >删除</el-button
          >
          <el-button
            style="margin: 10px 3px 3px 0px"
            @click="getEditBannerCate(scope.row._id)"
            type="primary"
            size="small"
            plain
            icon="el-icon-edit"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 新闻分类修改 -->
    <div v-for="item in editBannerCate" :key="item.index">
      <el-dialog
        title="banner分类修改"
        :visible.sync="bannerCateDialog"
        width="45%"
      >
        <el-form>
          <el-form-item label="banner分类">
            <el-input v-model="item.bannerType"> </el-input>
          </el-form-item>
          <el-form-item label="banner描述">
            <el-input v-model="item.bannerDesc"> </el-input>
          </el-form-item>

          <el-form-item label="bannerID">
            <el-input :disabled="true" v-model="item.bannerID"> </el-input>
          </el-form-item>
        </el-form>

        <el-button type="primary" @click="putEditBannerCate(item._id)"
          >点击修改</el-button
        >
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { timerfilter } from "../util/timerfilter";

export default {
  props: {
    maID: {},
  },
  data() {
    return {
      bannerCateDialog: false,
      model: {},
      bannerID: "",
      bannercate: [],
      editBannerCate: [],
    };
  },
  methods: {
    async saveBannerCate() {
      let params = {
        bannerType: this.model.bannerType,
        bannerDesc: this.model.bannerDesc,
        bannerID: this.bannerID,
      };
      try {
        const result = await this.$http.post("/bannercate/create", params);
        if (result.status === 200) {
          this.$message({
            type: "success",
            message: result.data.msg,
          });
          this.getBannerCate();
          this.model = [];
          this.createBannerID();
        }
      } catch (error) {
        console.log(error);
      }
    },
    //自动生成新闻ID
    createBannerID() {
      this.bannerID = Date.now();
    },
    async getBannerCate() {
      try {
        const result = await this.$http.get("/bannercate/getbannercate");
        this.bannercate = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    delBannerCate(id) {
      this.$confirm("此操作将永久删除且不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "waring",
        center: true,
      })
        .then(async () => {
          const res = await this.$http.delete("/bannercate/delbannercate", {
            params: { id },
          });
          if (res.status === 203) {
            console.log(res.data);
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getBannerCate();
          } else {
            this.$message(res.message);
          }
        })
        .catch((res) => {
          if (res === "cancel") {
            this.$message({
              type: "info",
              message: "取消删除",
            });
          } else {
            //console.log(res);
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        });
    },
    async getEditBannerCate(id) {
      try {
        this.bannerCateDialog = true;
        const result = await this.$http.get(
          "/bannercate/getbanneredit?id=" + `${id}`
        );
        this.editBannerCate = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    async putEditBannerCate(id) {
      try {
        this.bannerCateDialog = false;
        const result = await this.$http.put(
          "/bannercate/putbanneredit?id=" + `${id}`,
          ...this.editBannerCate
        );
        if (result.status == 201) {
          this.$message({
            type: "success",
            message: result.data.msg,
          });
          this.getBannerCate();
        }
      } catch (error) {
        console.log(error);
      }
      //console.log(newID);
    },
    //日期格式化插件
    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },
  },
  created() {
    this.createBannerID();
    this.getBannerCate();
  },
};
</script>
